var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"linkText",class:_vm.LinkTextStyleClass,style:(_vm.textColor),attrs:{"to":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }